import http from './http';

/**
 * 配置相关接口（站点配置 / 渠道 / 配额 / 系统配置各分区）
 */

/** 用户侧站点配置（公开） */
export function userConfig() {
  return http.get('/api/config/userConfig');
}

/** 存储渠道列表 */
export function channels(params) {
  return http.get('/api/config/channels', { params });
}

/** 存储配额查询 / 设置 */
export function getQuota() {
  return http.get('/api/config/quota');
}

export function setQuota(data) {
  return http.post('/api/config/quota', data);
}

/** 系统配置分区（page / upload / security / others） */
export function getSysConfig(section) {
  return http.get(`/api/config/sysConfig/${section}`);
}

export function saveSysConfig(section, settings) {
  return http.post(`/api/config/sysConfig/${section}`, settings);
}
